import { createFileRoute } from "@tanstack/react-router";
import { TwoFactorVerify } from "@/pages/2fa/TwoFactorVerify";

export const Route = createFileRoute("/auth/2fa")({
	component: TwoFactorVerify,
});
